import React from 'react';

const ZoomIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" aria-hidden="true">
        <circle cx="10.5" cy="10.5" r="6.5" />
        <line x1="15.5" y1="15.5" x2="21" y2="21" />
        <line x1="10.5" y1="7.5" x2="10.5" y2="13.5" />
        <line x1="7.5" y1="10.5" x2="13.5" y2="10.5" />
    </svg>
);

/* Clickable thumbnails that hand the chosen image up to the page-level lightbox.
   `priority` marks a grid that sits above the fold: its images load eagerly so
   they are not a lazily-loaded LCP element. `mobileCarousel` turns the grid
   into a horizontal swipe strip on phones (see the CSS) for galleries too long
   to stack in one column. */
const PhotoGrid = ({
    images,
    orientation = 'landscape',
    onSelect,
    priority = false,
    mobileCarousel = false,
}) => (
    <>
        <div
            className={`photo-grid photo-grid--${orientation}${mobileCarousel ? ' photo-grid--carousel' : ''}`}
        >
            {images.map((image) => (
                <button
                    key={image.src}
                    type="button"
                    className="photo"
                    aria-label={`View larger: ${image.alt}`}
                    onClick={() => onSelect(image)}
                >
                    <img
                        src={image.src}
                        alt={image.alt}
                        loading={priority ? 'eager' : 'lazy'}
                        fetchpriority={priority ? 'high' : 'auto'}
                        decoding="async"
                    />
                    <span className="photo__zoom">
                        <ZoomIcon />
                    </span>
                </button>
            ))}
        </div>
        {mobileCarousel && (
            <p className="photo-grid__hint" aria-hidden="true">
                Swipe to browse all {images.length} photos
            </p>
        )}
    </>
);

export default PhotoGrid;
